<template>
  <v-dialog v-model="dialog" persistent max-width="750px">
    <v-card v-if="dialog">
    <div class="viewer-container">
      <div class="dialog-header">
        <h1 class="header-title">퀴즈 답변</h1>
      </div>
      <v-card-text>
        <div class="viewer-title">{{ survey.title }}</div>
        <v-stepper v-model="e1" class="survey-answer-body">
          <v-container grid-list-md>
            <v-layout nowrap>
              <v-flex xs1 style="background: aliceblue;">
                <vue-perfect-scrollbar style="height: 400px;">
                  <template v-for="n in steps">
                    <v-stepper-step
                      class="survey-step"
                      :key="`${n}-step`"
                      :complete="e1 > n"
                      :step="n"
                      editable
                    >
                    </v-stepper-step>
                  </template>
                </vue-perfect-scrollbar>
              </v-flex>
              <v-flex xs10>
                <v-stepper-items>
                  <v-stepper-content
                    v-for="n in steps"
                    :key="`${n}-content`"
                    :step="n"
                  >
                    <vue-perfect-scrollbar>
                      <v-card v-if="survey.questions">
                        <v-container style="padding-left: 30px;">
                          <v-layout>
                            <v-flex xs12>
                              <v-text-field class="answer-type" label="질문" v-model="survey.questions[n - 1].question" readonly></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout class="answer-wrap">
                            <v-flex xs12>
                              <div v-if="survey.questions[n - 1].type === 'text'">
                                <v-textarea
                                  label="답변"
                                  v-model="answers[n - 1]"
                                />
                              </div>
                              <div v-if="survey.questions[n - 1].type !== 'text'">
                                <v-radio-group 
                                  v-if="survey.questions[n - 1].type === 'radio'"
                                  v-model="answers[n - 1]"
                                >
                                  <v-radio
                                    v-for="(item, index) in survey.questions[n - 1].items"
                                    :key="index"
                                    :label="item"
                                    :value="item"
                                  ></v-radio>
                                </v-radio-group>
                                <div style="margin-top: 30px;" v-else>
                                  <v-checkbox
                                    
                                    v-for="(item, index) in survey.questions[n - 1].items"
                                    v-model="answers[n - 1]"
                                    :key="index"
                                    :label="item"
                                    :value="item"
                                    style="margin-top: -25px !important; padding-top: 0px !important;"
                                  />
                                </div>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </vue-perfect-scrollbar>
                  </v-stepper-content>
                </v-stepper-items>
              </v-flex>
            </v-layout>
          </v-container>
        </v-stepper>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <button class="btnPrimary noIconButton" @click="save">
          답변완료
        </button>
        <button class="noIconButton" @click="cancel">취소</button>
      </v-card-actions>
    </div>
  </v-card>
  </v-dialog>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Util from '@/util';

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    dialog: { type: Boolean, default: false },
    survey: { type: Object, default: false },
    steps: { type: Number },
    meetingKey: { type: String },
    close: { type: Function },
  },
  data () {
    return {
      e1: 0,
      answers: [],
      surveyAnswers: {
        replier: 'admin',
        answers: null,
        meetingKey: '',
        surveyId: '',
      },
    };
  },
  watch: {
    dialog: {
      handler (val) {
        if (val && this.survey) {
          this.answers = this.survey.questions.map(question => {
            if (question.type === 'check') {
              return [];
            } else {
              return '';
            }
          });
        }
      }
    }
  },
  methods: {
    async save () {
      const noAnswers = this.answers.filter(answer => answer === null 
        || (typeof answer === 'string' && answer.trim() === ''));

      if (noAnswers.length > 0 || this.answers.length === 0) {
        alert('답변을 입력하지 않은 문항이 있습니다.');
        return;
      }
      this.surveyAnswers.answers = this.answers;
      this.surveyAnswers.surveyId = this.survey._id;
      this.surveyAnswers.meetingKey = this.meetingKey;

      console.log(`this.surveyAnswers`, this.surveyAnswers)
      await this.$http
        .post("/api/v1/surveys/answer", this.surveyAnswers)
        .then(async (response) => {
          if (response.status === 200) {
            alert('답변이 완료되었습니다.');
            this.close();
          }
        })
        .catch(error => console.log(error));
    },
    cancel () {
      this.close();
    }

  }
};
</script>

<style scoped>
.viewer-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.header-title {
  color: white;
  font-size: 18px;
  padding-left: 20px;
}

.dialog-header {
  width: 100%;
  height: 50px;
  background-color: #23408e;
}

.viewer-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  margin-left: 3px;
}

button,.btn {
  position: relative;
  display: inline-block;
  height: 30px;
  line-height: 28px;
  padding: 0 12px 0 34px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
  margin-left:5px;
  cursor: pointer;
  color:#555;
}
button.btnPrimary,.btnPrimary {color:#fff; background: #23408e;border-color:#23408e}
button.btnPrimary:hover,.btnPrimary:hover {color:#fff; background: #477ADB;border-color:#477ADB}
.btnsArea button:first-child {margin-left:0}
button.noIconButton {padding: 0 12px;}
button.onlyIconButton {padding: 0 8px;}
button.onlyIconButton img {vertical-align: middle;}
button.onlyIconButton.ico_search img {width:18px; position: relative; top:-2px;}
button.onlyIconButton.ico_search:hover img {	filter: invert(36%) sepia(0%) saturate(10%) hue-rotate(71deg) brightness(92%) contrast(89%);}
button:hover,button.btn:hover {color: #23408e; border-color: #23408e;}
button:hover i,button.btn:hover i {color: #23408e;}
button.btnPrimary:hover i {color: #fff;}
button.btnDisable,button.btnDisable:hover {background:#f1f1f1;border-color:#ddd; color:#999; cursor:not-allowed}
button.noIconButton.small {height:23px;padding: 0 10px;font-size:12px;line-height: 20px;} 
</style>


// WEBPACK FOOTER //
// src/components/popup/KsdSurveyViewer.vue